import { axiosApi } from "app/configs/axiosConfig";

export const fetchRepresentativeById = async (id) => {
  try {
    const response = await axiosApi.get(`/representative/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching representative:', error);
    return null;
  }
};

export default fetchRepresentativeById;
